import Mentioned from './Mentioned';

export default Mentioned;
